import { css } from "styled-components";

import { greyMui } from "../declarations";

export const dividerStyles = css`
  .divider-form {
    margin-block: 10px;
    border-top: 1px solid ${greyMui._300};
  }
`;
